import React from 'react';
import { InstagramIcon, MessageCircleIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { whatsappLink } from '../lib/whatsapp';
import { useLanguage } from '../lib/i18n';
const scrollTo = (id: string) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const links = [{
    label: t('nav.home'),
    href: '#inicio'
  }, {
    label: t('nav.experiences'),
    href: '#experiencias'
  }, {
    label: t('nav.gallery'),
    href: '#galeria'
  }, {
    label: t('nav.reviews'),
    href: '#opiniones'
  }, {
    label: t('nav.contact'),
    href: '#contacto'
  }];
  return <footer className="bg-volcanic text-ivory px-5 sm:px-8 lg:px-24 pt-16 sm:pt-24 lg:pt-32 pb-8 sm:pb-12 w-full overflow-hidden" data-id="element-133" data-mp="29yno3sf6hjhp">
      <div className="grid lg:grid-cols-12 gap-12 sm:gap-16 lg:gap-20 items-start max-w-[1400px] mx-auto" data-id="element-134" data-mp="2ez1joazlf0yu">
        <div className="lg:col-span-5" data-id="element-135" data-mp="3la28msb12zu6">
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-136" data-mp="3gah1hulpfl6d">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="sm:w-8 sm:h-8" data-id="element-137" data-mp="3gck0330xammp">
              <circle cx="12" cy="10" r="6" fill="#C97B63" fillOpacity="0.9" data-id="element-138" data-mp="82qt3uy8hxus" />
              <path d="M4 16C6 16 7 14 10 14C13 14 14 16 17 16C20 16 21 14 23 14" stroke="#7B8B6F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-139" data-mp="80nsyi3daocc" />
              <path d="M2 19C4 19 5 17 8 17C11 17 12 19 15 19C18 19 19 17 21 17" stroke="#7B8B6F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" data-id="element-140" data-mp="cv1pwoxoh3j4" />
            </svg>
            <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl leading-none font-light tracking-[0.15em]" data-id="element-141" data-mp="two2xqn2pb5q">
              YES PICNIC TENERIFE
            </h3>
          </div>
          <p className="font-script text-terracotta text-xl sm:text-2xl mb-6 sm:mb-8" data-id="element-142" data-mp="13s9980z6cxla">
            Tenerife · luxury picnics
          </p>
          <p className="text-ivory/80 leading-relaxed max-w-sm text-[13px] sm:text-sm font-light" data-id="element-143" data-mp="18m3sx4es5ckd">
            {t('footer.desc')}
          </p>
        </div>

        <div className="lg:col-span-3" data-id="element-144" data-mp="1hjnukegk1avi">
          <p className="uppercase tracking-[0.2em] text-[9px] sm:text-[10px] mb-5 sm:mb-6 text-ivory/60 font-semibold" data-id="element-145" data-mp="1hms47rcsgytk">
            {t('footer.nav')}
          </p>
          <ul className="space-y-3 sm:space-y-4 text-[13px] sm:text-sm font-light" data-id="element-146" data-mp="1rhk3czm0rtqg">
            {links.map(l => <li key={l.href} data-id="element-147" data-mp="3oczpzct5yl73">
                <a href={l.href} onClick={e => {
              e.preventDefault();
              scrollTo(l.href);
            }} className="inline-flex items-center group cursor-pointer hover:text-terracotta transition-colors duration-300" data-id="element-148" data-mp="3ta8bnndit7d3">
                  <span className="w-0 h-px bg-terracotta group-hover:w-4 sm:group-hover:w-6 transition-all duration-500 mr-0 group-hover:mr-2 sm:group-hover:mr-3" data-id="element-149" data-mp="21m0krxf5diwd" />
                  <span data-id="element-150" data-mp="2tdzjgrjoazsp">{l.label}</span>
                </a>
              </li>)}
          </ul>
        </div>

        <div className="lg:col-span-4" data-id="element-151" data-mp="2pbuva8bzuvdg">
          <p className="uppercase tracking-[0.2em] text-[9px] sm:text-[10px] mb-5 sm:mb-6 text-ivory/60 font-semibold" data-id="element-152" data-mp="2pcw4s8dd39t2">
            {t('footer.contact')}
          </p>
          <div className="space-y-4 sm:space-y-5 text-[13px] sm:text-sm font-light" data-id="element-153" data-mp="2fezufis90iw0">
            <a href="tel:+34689621262" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-154" data-mp="18ynvhfhlqwzd">
              <PhoneIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-155" data-mp="141e7m49v2tdn" />
              <span data-id="element-156" data-mp="2wmptiv6ykgqi">+34 689 621 262</span>
            </a>
            <a href="mailto:yes.picnic.tenerife@gmail.com" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-157" data-mp="2woanojpd1xnu">
              <MailIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-158" data-mp="2ns1ispim66ub" />
              <span data-id="element-159" data-mp="3bk8gbs02sjvb">yes.picnic.tenerife@gmail.com</span>
            </a>
            <a href={whatsappLink('general', lang)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-160" data-mp="3fkag1vm9337y">
              <MessageCircleIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-161" data-mp="36mgmutjs8pp0" />
              <span data-id="element-162" data-mp="1v6iaafpeblj1">{t('footer.wa')}</span>
            </a>
            <a href="https://www.instagram.com/yes.picnic.tenerife/" target="_blank" rel="noopener noreferrer" aria-label="Síguenos en Instagram @yes.picnic.tenerife" className="flex items-center gap-3 hover:text-terracotta transition-colors duration-300" data-id="element-163" data-mp="1nlxsuagevsx2">
              <InstagramIcon size={14} strokeWidth={1.5} className="sm:w-4 sm:h-4" data-id="element-164" data-mp="1rom1oi54kzu1" />
              <span data-id="element-165" data-mp="13vm0wonwyffn">@yes.picnic.tenerife</span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-ivory/10 mt-12 sm:mt-20 lg:mt-24 pt-8 sm:pt-10 flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-6 text-center md:text-left text-[10px] sm:text-xs text-ivory/60 max-w-[1400px] mx-auto" data-id="element-166" data-mp="1dnrt9zi2uyvd">
        <span className="uppercase tracking-[0.15em] sm:tracking-[0.2em] font-medium" data-id="element-167" data-mp="l6fht0j7jltb">
          {t('footer.copy')}
        </span>
        <span className="font-script text-terracotta text-base sm:text-lg capitalize tracking-normal" data-id="element-168" data-mp="g848qs0qlfc5">
          Made with love in Tenerife
        </span>
      </div>
    </footer>;
}